export default `
  <h1>Wanderer (Amsterdam), 2026</h1>
  <p>Wanderer is an autonomous, digital flâneur, an internet-based entity that roams the map of our physical
        world through an endless sequence of directional choices, recorded immutably on the blockchain and visualized
        through web-based map services.</p>
  <p>Drawing on the Situationist practice of the dérive, the act of drifting through urban environments guided by
        emotion and chance, this work reimagines the wandering artist as a persistent algorithmic agent, animated not
        by human will but by server logic and blockchain transactions.</p>
  <p>While walking, Wanderer reflects on the early promise of the Internet as an open and free space, at a time
        when that openness is increasingly being enclosed.</p>
  <h2>About</h2>
  <p>At Paris Photo 2025 at the Office Impart booth, Wanderer premiered as a permanent online flaneur starting at the Grand Palais.</p>
  <p>This version of Wanderer is a time-limited performance that will run for the duration of the exhibition '
    <a href="https://www.rozenstraat.com/event/enter-public-space-enter-public-stage/" target="_blank">Enter/Public/Space</a>' at ROZENSTRAAT.
  </p>
  <p>Wanderer (Amsterdam) will begin walking at 6.30 PM on 3 September 2026.</p>
  <p>You can follow wanderer on your phone
    <a href="https://wandereramsterdam.leegte.org" target="_blank">here</a>.
  </p>
  <h2>How the work was made</h2>
  <p>The idea began with imagining an autonomous internet agent capable of wandering the world.</p>
  <p>The work consists of a server-based application that communicates with a crypto wallet. By sending transactions containing GPS coordinates in their metadata, the entire walk is immutably logged on the
        blockchain. The transaction hash from each step acts as a pseudo-random generator that determines the next
        move.</p>
  <p>This makes the path deterministic: if the walk were replayed using the wallet’s transaction history, it would
        retrace exactly the same journey.</p>
  <p>The work was developed by
    <a href="https://jaspervanloenen.com/" target="_blank">Jasper van Loenen</a>.
  </p>
  <h2>About the artist</h2>
  <p>Since the late 1990s, I have been creating art on the Internet, websites, apps, installations, videos,
        prints, sculptures, audio works, and drawings. The networked computer has always been my muse, a lens through
        which I explore the peculiarities and poetry of the digital world.</p>
  <p>My work has been exhibited at Whitechapel Gallery, Centre Pompidou, Stedelijk Museum Amsterdam, Van Gogh
        Museum, ZKM Karlsruhe, and Ludwig Museum, and is held in both private and institutional collections.</p>
  <p>Visit
    <a href="https://www.leegte.org/" target="_blank">www.leegte.org</a> to explore my work.
  </p>
  <p>Represented by
    <a href="https://www.upstreamgallery.nl/" target="_blank">Upstream Gallery</a> (Amsterdam) and
    <a href="https://officeimpart.com/" target="_blank">Office Impart</a> (Berlin).
  </p>
`;
